import {
  MARKETING_MESSAGE,
  NOTIFICATION,
  HELP_CONTENT,
  IActionString,
  IActionOptionalString,
} from '@store/types';

import {
  notification as notificationRequest,
  marketingMessage as marketingMessageRequest,
  helpContent as helpContentRequest,
} from '@services/auth';

export const getMarketingMessage = (): any => {
  return (dispatch: (action: IActionString) => void) => {
    return marketingMessageRequest()
      .then((message: string) =>
        dispatch({
          type: MARKETING_MESSAGE,
          payload: message,
        })
      )
      .catch(() => {});
  };
};

export const getNotification = (): any => {
  return (dispatch: (action: IActionOptionalString) => void) => {
    return notificationRequest()
      .then((message: string | undefined) =>
        dispatch({
          type: NOTIFICATION,
          payload: message,
        })
      )
      .catch(() => {});
  };
};

export const getHelpContent = (): any => {
  return (dispatch: (action: IActionString) => void) => {
    return helpContentRequest()
      .then((content: string) =>
        dispatch({
          type: HELP_CONTENT,
          payload: content || '',
        })
      )
      .catch(() => {});
  };
};
